.fj{border-radius:0.5rem;}